import React, { Component } from "react";
import avatar from "../../../images/avatar.jpg";
import avatarDeleted from "../../../images/avatar-deleted.png";
import FileStackService from "../../../services/filestack.service";
import {
  fallbackOnImageError,
  isFileStackUrl,
  resolveImageUrl,
} from "../../../util/filestack";

class UserAvatarImage extends Component<{ user: any, className?: string }> {
  state = {
    policyAndSignatureImg: '' as string,
  }

  async componentDidMount(): Promise<void> {
    try {
      if (isFileStackUrl(this.props.user?.userImageUrl)) {
        const policyUserImg = await FileStackService.getFileStackSecreteCode(
          this.props.user.userImageUrl, false
        );
        this.setState({ policyAndSignatureImg: policyUserImg.data });
      }
    } catch(err: any) {
      console.log("Erro ao obter credenciais - ERROR: ", err);
    }
  }

  render() {
    const { user, className } = this.props;
    const fallbackUrl = user.deleted ? avatarDeleted : avatar;
    return (
      <img
        className={className}
        src={resolveImageUrl(
          user.userImageUrl,
          this.state.policyAndSignatureImg,
          fallbackUrl
        )}
        onError={fallbackOnImageError(fallbackUrl)}
        alt={user.displayName}
      />
    );
  }
}

export default UserAvatarImage;
